const NAME = "TYPES_OF_SCORE";

export default NAME;
